// extracted by mini-css-extract-plugin
export var borderRadius = "_gg-4";
export var large = "_gg-3";
export var logoContainer = "_gg-0";
export var nameLogo = "_gg-2";
export var small = "_gg-1";